import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            选择你的购票渠道
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            五大正规购票渠道全面对比，帮你找到最安全、最适合的方式
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <i className={`${cat.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed mb-3 line-clamp-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.articleCount} 篇指南 &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}